module.exports = __webpack_public_path__ + "img/logo-06.086f38a0.png";